import { FC } from "react";
import { useI18n } from "../../hooks/useTranslations";
import { useSubsidiariesApi } from "../../http/subsidiaries/api";
import HistoryDialog from "../ui/HistoryDialog";
import VersionDialog from "../ui/VersionDialog";

type SubsidiaryHistoryDialogProps = {
  itemToShowVersionsId: string;
  itemVersionToShowVersions: number;
  onClose: () => void;
};

const SubsidiaryHistoryDialog: FC<SubsidiaryHistoryDialogProps> = ({
  itemToShowVersionsId,
  itemVersionToShowVersions,
  onClose,
}) => {
  const i18n = useI18n();
  const subsidiariesApi = useSubsidiariesApi();

  return (
    <HistoryDialog
      title={i18n.t.subsidiaries.versions}
      lastVersion={itemVersionToShowVersions}
      entityId={itemToShowVersionsId}
      getEntityVersionHook={subsidiariesApi.getAdminSubsidiaryVersion}
      getHistory={subsidiariesApi.getAdminSubsidiaryHistory}
      onClose={onClose}
      renderForm={(headers, dataVersion) => (
        <>
          <VersionDialog.Table headers={headers}>
            {dataVersion.current?.name != dataVersion.next.name && (
              <tr>
                <VersionDialog.Field
                  label={i18n.t.common.name}
                  value={dataVersion.current?.name}
                  edited={dataVersion.next.name}
                />
              </tr>
            )}

            {dataVersion.current?.allowMultiPlates != dataVersion.next.allowMultiPlates && (
              <tr>
                <VersionDialog.Field
                  label={i18n.t.common.allowMultiplePlates}
                  value={dataVersion.current?.allowMultiPlates}
                  edited={dataVersion.next.allowMultiPlates}
                />
              </tr>
            )}

            {dataVersion.current?.countryIsoCodeAlpha2 != dataVersion.next.countryIsoCodeAlpha2 && (
              <tr>
                <VersionDialog.Field
                  label={i18n.t.common.countryIsoCode}
                  value={dataVersion.current?.countryIsoCodeAlpha2}
                  edited={dataVersion.next.countryIsoCodeAlpha2}
                />
              </tr>
            )}

            {dataVersion.current?.vatDeductionCode != dataVersion.next.vatDeductionCode && (
              <tr>
                <VersionDialog.Field
                  label={i18n.t.common.vatDeductionCode}
                  value={dataVersion.current?.vatDeductionCode}
                  edited={dataVersion.next.vatDeductionCode}
                />
              </tr>
            )}
            {dataVersion.current?.vatServiceCode != dataVersion.next.vatServiceCode && (
              <tr>
                <VersionDialog.Field
                  label={i18n.t.common.vatServiceCode}
                  value={dataVersion.current?.vatServiceCode}
                  edited={dataVersion.next.vatServiceCode}
                />
              </tr>
            )}
            {dataVersion.current?.defaultLanguage != dataVersion.next.defaultLanguage && (
              <tr>
                <VersionDialog.Field
                  label={i18n.t.common.defaultLanguage}
                  value={dataVersion.current?.defaultLanguage}
                  edited={dataVersion.next.defaultLanguage}
                />
              </tr>
            )}
            {dataVersion.current?.semiramisOrganizationCode != dataVersion.next.semiramisOrganizationCode && (
              <tr>
                <VersionDialog.Field
                  label={i18n.t.common.semiramisOrganizationCode}
                  value={dataVersion.current?.semiramisOrganizationCode}
                  edited={dataVersion.next.semiramisOrganizationCode}
                />
              </tr>
            )}
          </VersionDialog.Table>
        </>
      )}
    />
  );
};

export default SubsidiaryHistoryDialog;
